import { IconComponent } from "../icon.types";

export const CatCutIcon: IconComponent = (props) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="624.000000px"
    height="217.000000px"
    viewBox="0 0 624.000000 217.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
      <path
        d="M3258 2132 l-88 -37 0 -622 0 -623 -62 0 c-35 0 -337 12 -673 26
  l-609 26 -24 -29 c-13 -15 -73 -98 -134 -183 -142 -198 -176 -240 -194 -240
  -9 0 -120 212 -296 565 l-283 565 -327 0 c-181 0 -328 -3 -328 -7 0 -5 11
  -119 24 -255 l24 -247 359 -533 358 -533 2143 -3 2142 -2 0 248 c0 180 -3 251
  -12 260 -9 9 -9 15 0 24 10 10 78 7 320 -11 169 -13 328 -27 353 -30 l47 -6
  -68 -150 c-37 -82 -85 -192 -108 -242 l-41 -93 112 0 113 0 117 276 117 275
  -71 80 c-40 43 -75 79 -80 79 -61 0 -815 42 -818 46 -3 3 -10 297 -16 654 -5
  356 -12 650 -15 653 -3 2 -41 20 -86 39 l-80 35 -219 -168 -219 -167 -201 4
  c-110 2 -329 7 -488 10 l-287 6 -152 172 c-83 94 -154 172 -157 173 -3 1 -45
  -15 -93 -35z m479 -974 c61 -15 115 -69 133 -131 26 -96 -4 -215 -70 -270 -91
  -77 -230 -44 -285 66 -74 153 10 339 158 346 10 1 39 -4 64 -11z m1106 -18
  c19 -13 49 -45 67 -71 27 -40 33 -60 38 -117 4 -62 2 -75 -23 -121 -92 -168
  -305 -144 -371 41 -41 116 9 234 121 285 44 20 126 11 168 -17z m-567 -397
  c20 -94 39 -123 109 -168 47 -29 55 -39 55 -65 0 -57 -58 -86 -124 -60 -14 5
  -46 28 -71 51 l-44 41 -28 -20 c-124 -87 -213 -79 -230 21 -5 35 -5 36 33 43
  90 16 148 70 161 149 l6 35 63 0 c61 0 64 -1 70 -27z"
      />
  </svg>
);
